import { useState } from "react"
import type { FC } from "react"

import debounce from "lodash/debounce"

import { useDispatchError } from "~/containers/Proposal/state/notifications/QueryErrorModal"
import { useProposalActions } from "~/containers/Proposal/state/proposal/proposal-context"
import type { Design } from "~/graphql/client"
import { useDuplicateDesignRequestMutation } from "~/graphql/client"
import { useGraphqlClient } from "~/hooks/graphql"

import { ReactComponent as XIcon } from "@svg/x.svg"

import { Buttons, CharsLeft, Header, Info, Wrapper } from "./styles"

export const Duplicate: FC<{
  close: VoidFunction
  designRevision?: Design
  disabled?: boolean
}> = ({ close, designRevision, disabled }) => {
  const [message, setMessage] = useState<string>(``)
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length <= 255) setMessage(e.target.value)
  }
  const { client } = useGraphqlClient()
  const onError = useDispatchError()
  const { refetch } = useProposalActions()
  const duplicateDesignRequestMutation = useDuplicateDesignRequestMutation(
    client,
    {
      onError,
      onSuccess: async () => {
        close()
        await refetch()
      },
    },
  )
  const debouncedDuplicate = debounce(async (designRequestId, message) => {
    duplicateDesignRequestMutation.mutate({ designRequestId, message })
  }, 1500)
  const handleSave = async () => {
    if (!designRevision?.designRequest?.id) return
    debouncedDuplicate(designRevision.designRequest.id, message)
  }

  return (
    <Wrapper isSaving={duplicateDesignRequestMutation.isLoading}>
      <Header>
        <h1>Duplicate Request</h1>
        <XIcon onClick={close} />
      </Header>
      <textarea value={message} onChange={handleChange} />
      <Info>
        <p>The maximum allowed number of characters is 255</p>
        <CharsLeft>{255 - message.length} left</CharsLeft>
      </Info>
      <Buttons>
        <button onClick={handleSave} disabled={disabled}>
          Duplicate
        </button>
        <button onClick={close}>Cancel</button>
      </Buttons>
    </Wrapper>
  )
}
